<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-8">
            <div class="flmid">
                <div class="flgrow">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                        [(ngModel)]="pService.searchTerm" autocomplete="off" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary">
                                <em class="fa fa-search"></em>
                            </button>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container prel">
    
            
                <div class="row">
                    <div class="c12">
                        <div class="card mb-3">
                            <div class="card-header d-flex">
                                <h4 class="card-title" translate>lblFeature</h4>
                                <div class="ml-auto">
                                    <button type="button" aria-label="Center Align" class="btn btn-primary mr-sm-2 mb-1" *ngIf="userRoleRightsDetails.canEdit" (click)="onSaveChanges(featureList)"
                                    translate>lblSaveChanges</button>
                                </div>
                              </div>
            
                            <div class="table-responsive">
            
                            
                            <table class="tablest1">
                                <thead>
                                    <tr>
                                        <th style="width: 55px" scope="col">#</th>
                                        <th scope="col" sortable="featureName" (sort)="onSort($event)" translate>lblFeature</th>
                                        <th scope="col" sortable="isActive" (sort)="onSort($event)" translate>lblIsEnable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="featureList && featureList.length > 0; else load_else">
                                        <tr *ngFor="let role of featureList; let i=index">
                                            <td>{{role.row}}</td>
                                            <td>
                                                <ngb-highlight [result]="role.featureName" [term]="pService.searchTerm">
                                                </ngb-highlight>
                                            </td>
                                            <td>
                                                <div class="btn btn-link px-2">
                                                    <div class="custom-control custom-switch" *ngIf="isParentDmsFlagEnabled">
                                                        <input type="checkbox" class="custom-control-input" [checked]="role.isActive" 
                                                        id="users-CanDelete{{i}}" [(ngModel)]="role.isActive" (change)="checkDependencyOnParentDmsFlag(role)">
                                                        <label class="custom-control-label" for="users-CanDelete{{i}}"></label>
                                                    </div>
                                                    <div class="custom-control custom-switch" *ngIf="!isParentDmsFlagEnabled">
                                                        <input type="checkbox" class="custom-control-input" [checked]="role.isActive" 
                                                        id="users-CanDelete{{i}}" [(ngModel)]="role.isActive" [disabled]="role.isDependOnMainDMSFeature" (change)="checkDependencyOnParentDmsFlag(role)">
                                                        <label class="custom-control-label" for="users-CanDelete{{i}}"></label>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #load_else>
                                        <tr>
                                            <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                            </div>
            
                            <div class="card-footer">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex justify-content-between">
                                        <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                                            [pageSize]="pService.pageSize" [maxSize]="3">
                                        </ngb-pagination>
                                        <select class="custom-select mx-2" style="width: auto" name="pageSize"
                                            [(ngModel)]="pService.pageSize">
                                            <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                                                {{item.label}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                                        <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$  | async}}&nbsp;<span class="font17 fontnormal"
                                            translate>lblResults</span>
                                    </div>
                    
                                </div>
                            </div>
                        </div>
                       
                        
                    </div>
                </div>
            
        
       
    
</div>